export type Locale =
	| 'cs'
	| 'da'
	| 'de'
	| 'en'
	| 'en_GB'
	| 'en_ZZ'
	| 'es'
	| 'fi'
	| 'fr'
	| 'hr'
	| 'hu'
	| 'it'
	| 'ja'
	| 'ko'
	| 'nb'
	| 'nl'
	| 'pl'
	| 'pt_BR'
	| 'ru'
	| 'sl'
	| 'sr_RS'
	| 'sr_YR'
	| 'sv'
	| 'th'
	| 'tr'
	| 'uk'
	| 'vi'
	| 'zh'
	| 'zh_TW';

type I18nModule = typeof import('./cs');

export const importI18n: (locale: Locale) => Promise<I18nModule> = async (locale: Locale) => {
	switch (locale) {
		case 'cs':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-cs" */ './cs'
			) as Promise<I18nModule>;
		case 'da':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-da" */ './da'
			) as Promise<I18nModule>;
		case 'de':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-de" */ './de'
			) as Promise<I18nModule>;
		case 'en':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-en" */ './en'
			) as Promise<I18nModule>;
		case 'en_GB':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-en_GB" */ './en_GB'
			) as Promise<I18nModule>;
		case 'en_ZZ':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-en-ZZ" */ './en_ZZ'
			) as Promise<I18nModule>;
		case 'es':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-es" */ './es'
			) as Promise<I18nModule>;
		case 'fi':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-fi" */ './fi'
			) as Promise<I18nModule>;
		case 'fr':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-fr" */ './fr'
			) as Promise<I18nModule>;
		case 'hr':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-hr" */ './hr'
			) as Promise<I18nModule>;
		case 'hu':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-hu" */ './hu'
			) as Promise<I18nModule>;
		case 'it':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-it" */ './it'
			) as Promise<I18nModule>;
		case 'ja':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-ja" */ './ja'
			) as Promise<I18nModule>;
		case 'ko':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-ko" */ './ko'
			) as Promise<I18nModule>;
		case 'nb':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-nb" */ './nb'
			) as Promise<I18nModule>;
		case 'nl':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-nl" */ './nl'
			) as Promise<I18nModule>;
		case 'pl':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-pl" */ './pl'
			) as Promise<I18nModule>;
		case 'pt_BR':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-pt_BR" */ './pt_BR'
			) as Promise<I18nModule>;
		case 'ru':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-ru" */ './ru'
			) as Promise<I18nModule>;
		case 'sl':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-sl" */ './sl'
			) as Promise<I18nModule>;
		case 'sr_RS':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-sr_RS" */ './sr_RS'
			) as Promise<I18nModule>;
		case 'sr_YR':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-sr_YR" */ './sr_YR'
			) as Promise<I18nModule>;
		case 'sv':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-sv" */ './sv'
			) as Promise<I18nModule>;
		case 'th':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-th" */ './th'
			) as Promise<I18nModule>;
		case 'tr':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-tr" */ './tr'
			) as Promise<I18nModule>;
		case 'uk':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-uk" */ './uk'
			) as Promise<I18nModule>;
		case 'vi':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-vi" */ './vi'
			) as Promise<I18nModule>;
		case 'zh':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-zh" */ './zh'
			) as Promise<I18nModule>;
		case 'zh_TW':
			return import(
				/* webpackChunkName: "search-ai-translations-i18n-zh_TW" */ './zh_TW'
			) as Promise<I18nModule>;
	}
};
